module.exports = "<h2 id=\"icon-\">Icon组件的使用</h2>\n<pre><code class=\"lang-jsx\">  &lt;Icon type=&quot;setting&quot;/&gt;\n</code></pre>\n<table>\n<thead>\n<tr>\n<th>props</th>\n<th>说明</th>\n<th>参数类型</th>\n<th>默认值</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>type</td>\n<td>图标类型</td>\n<td>string<strong>（必填）</strong></td>\n<td>无</td>\n</tr>\n</tbody>\n</table>\n";


//////////////////
// WEBPACK FOOTER
// ./example/icon_test/icon.md
// module id = 223
// module chunks = 0